<template>
  <div>
    <label
      v-if="isLabelPresent"
      :for="id"
      :class="`block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-2 ${labelClass}`"
    >
      {{ $t(label) }}
      <span v-if="required" class="text-red-600">*</span>
    </label>
    <div class="relative">
      <template v-if="$slots.prependIcon">
        <div
          class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
        >
          <slot name="prependIcon" />
        </div>
      </template>
      <Field
        :id="id"
        :name="name"
        :type="type"
        :class="[fieldClass, $slots.prependIcon ? 'pl-10' : '']"
        :placeholder="placeholder"
        :disabled="disabled"
        v-model="internalValue"
      />
      <div
        v-if="trailingAddOns"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
      >
        <span class="text-gray-500 sm:text-sm">{{ trailingAddOns }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Field } from "vee-validate";

export default {
  components: {
    Field,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    labelClass: {
      type: String,
      default: "font-semibold",
    },
    name: {
      type: String,
      required: false,
      default: (props) => props.id,
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      required: true,
    },
    fieldClass: {
      type: String,
      default:
        "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6",
    },
    trailingAddOns: {
      type: String,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    isLabelPresent() {
      return !(this.label == null || this.label.length === 0);
    },
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
